'use strict';

angular.module('app.profile', ['ui.router', 'angular-img-cropper', 'sotos.crop-image'])

    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider) {
        $stateProvider.state('home.profile', {
            requireLogin: true,
            url: 'profile',
            templateUrl: 'app/profile/partials/index.html?app_v=deployDate',
            data: {
                authorizedRoles: ['User', 'Administrator', 'Achoo Analyst'],
                navMarker: ['profile', 'settings']
            },
            controller: 'ProfileCtrl'
        })

            .state('home.profileChangePassword', {
                requireLogin: true,
                url: 'profile/changepassword',
                templateUrl: 'app/profile/partials/changePassword.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['User', 'Administrator', 'Achoo Analyst'],
                    navMarker: ['profile', 'changepassword']
                },
                controller: 'ChangePasswordCtrl'
            })

            .state('home.profileBilling', {
                requireLogin: true,
                url: 'profile/billing',
                templateUrl: 'app/profile/partials/billing.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['User', 'Administrator', 'Achoo Analyst'],
                    navMarker: ['profile', 'billing']
                },
                controller: 'BillingCtrl'
            })
    }])

    .controller('ProfileCtrl', function ($scope, $rootScope, $http, $upload, localStorageService) {
        var definitions = angular.copy($rootScope.definitions);
        var currentUserData = $rootScope.currentUser;
        $scope.croppedImage = null;
        $scope.croppedImageOptions = {};
        $scope.croppedImageOptions.image = null;
        $scope.croppedImageOptions.viewSizeWidth = 150;
        $scope.croppedImageOptions.viewSizeHeight = 150;
        $scope.croppedImageOptions.viewShowRotateBtn = true;
        $scope.croppedImageOptions.rotateRadiansLock = true;
        $scope.croppedImageOptions.outputImageWidth = 20;
        $scope.croppedImageOptions.outputImageHeight = 20;
        $scope.croppedImageOptions.outputImageRatioFixed = false;
        $scope.croppedImageOptions.outputImageType = "jpeg";
        $scope.croppedImageOptions.outputImageSelfSizeCrop = true;
        $scope.croppedImageOptions.viewShowCropTool = true;

        $scope.countryListData = definitions.countries;

        var updateCompany = currentUserData.company;

        $scope.profile = {
            firstName: currentUserData.firstName,
            lastName: currentUserData.lastName,
            email: currentUserData.email,
            company: updateCompany,
            address: currentUserData.address && currentUserData.address.length > 0 ? currentUserData.address[0] : null
        };

        if (typeof ($scope.profile.address) === 'undefined') {
            $scope.profile.address = {
                country: currentUserData.company
            };
        }

        if ($scope.profile.address && $scope.profile.address.country != null &&
            $scope.profile.address.country.id > 0) {
            $scope.countryListData.forEach(function (val, index) {
                if (val.id == $scope.profile.address.country.id) $scope.countryListData[index].ticked = true;
            });
        }

        var dataURItoBlob = function (dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = decodeURI(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var array = [];
            for (var i = 0; i < byteString.length; i++) {
                array.push(byteString.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: mimeString });
        };

        $scope.uploadCroppedImage = function () {

            var blob = dataURItoBlob($scope.croppedImage);
            var fd = new FormData();
            fd.append("picture", blob);

            var req = {
                url: $rootScope.apiUrl + 'upload',
                method: 'POST',
                headers: { 'Content-Type': undefined },
                data: fd
            }

            $http(req)
                .success(function (response) {
                    $scope.croppedImage = response.image;
                    $scope.save();
                })
                .error(function (response) {

                })

        }

        $scope.save = function () {

            $scope.countryListData.forEach(function (val) {
                if (val.ticked === true)
                    $scope.profile.address.country = val.id;
            });

            $scope.profile.image = $scope.croppedImage;

            // The update user profile api doesn't require company's projects,
            // then to reduce the size of request body we should remove it
            if ($scope.profile.company) {
                delete $scope.profile.company.projects;
            }

            var req = {
                url: $rootScope.apiUrl + 'user/updateprofile',
                method: 'POST',
                data: JSON.stringify($scope.profile)
            }

            $http(req).success(function (response) {
                currentUserData.firstName = $scope.profile.firstName;
                currentUserData.lastName = $scope.profile.lastName;
                currentUserData.email = $scope.profile.email;
                if ($scope.profile.address != null) {
                    if (Array.isArray(currentUserData.address) && currentUserData.address.length > 0) {
                      currentUserData.address[0] = $scope.profile.address;
                    } else {
                      currentUserData.address = [$scope.profile.address];
                    }
                    currentUserData.address[0].country = { id: $scope.profile.address.country };
                }
                currentUserData.company = currentUserData.company;
                currentUserData.image = $scope.croppedImage ? $scope.croppedImage : currentUserData.image;

                //update local storage with new project data
                localStorageService.set('currentUser', currentUserData);
                $rootScope.currentUser = currentUserData;

                $scope.errorMessage = false;
                $scope.croppedImageOptions.image = null;

            })
                .error(function (data) {
                    $scope.errorMessage = data.message;
                });
        }

        $scope.updateProfile = function () {
            if ($scope.croppedImageOptions.image != null) {
                $scope.$broadcast('cropImageSave');
            } else {
                $scope.save();
            }

        }
    })
    .controller('ChangePasswordCtrl', function ($scope, $rootScope, $http) {
        $scope.save = function (isValid) {
            $scope.errorMessage = null;

            if (isValid) {
                $scope.profile.flag = false;

                var req = {
                    url: $rootScope.apiUrl + 'changepassword',
                    method: 'POST',
                    data: JSON.stringify($scope.profile)
                }

                $http(req).success(function (data) {

                    $scope.successMessage = data.message;
                })
                    .error(function (data) {
                        $scope.errorMessage = data.message;

                        for (var propertyKey in data) {
                            //$scope.newProject["project_" + propertyKey].$setValidity("required", false);

                            return;
                        }
                    });
            }
        }
    })

    .controller('BillingCtrl', function ($scope, $rootScope) {
        var definitions = angular.copy($rootScope.definitions);
        $scope.countryListData = definitions.countries;
        $scope.data = {
            mentions: 10,
            projects: 1,
            area: 1,
            customers: 100000,
            packageName: 'Enterprise',
            invoiceEmailList: [{ id: 2, email: 'miralem@google.com' }],
            invoices: [
                { invoice: 'INV 007487', invoice_number: '457/1', date: moment().format('MMM DD, YYYY'), due_date: moment().add(3, 'day').format('MMM DD, YYYY'), amount: 1599, paid: true },
                { invoice: 'INV 007488', invoice_number: '457/2', date: moment().format('MMM DD, YYYY'), due_date: moment().add(3, 'day').format('MMM DD, YYYY'), amount: 1599, paid: true },
                { invoice: 'INV 007489', invoice_number: '457/3', date: moment().format('MMM DD, YYYY'), due_date: moment().add(3, 'day').format('MMM DD, YYYY'), amount: 2846, paid: false },
                { invoice: 'INV 007490', invoice_number: '457/4', date: moment().format('MMM DD, YYYY'), due_date: moment().add(3, 'day').format('MMM DD, YYYY'), amount: 1599, paid: true }
            ]
        }
    })